import { FaroButton } from "@faro-lotv/flat-ui";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useAppParams } from "@router/router-helper";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useAppSelector } from "@store/store-helper";
import { isAlphaTestingEnabledSelector } from "@store/app/app-selector";
import { RuntimeUtils } from "@stellar/web-core";
import { runtimeConfig } from "@src/runtime-config";

/** Component to show the button add credits */
export function AddCredits(): JSX.Element | null {
  const { trackEvent } = useTrackEvent();
  const { companyId } = useAppParams();
  const { navigateToCreditsPage } = useAppNavigation();
  const isAlphaTestingEnabled = useAppSelector(isAlphaTestingEnabledSelector);
  const isProduction = RuntimeUtils.isProductionEnvironment(
    runtimeConfig.appEnv
  );

  function handleAddCredits(): void {
    trackEvent({
      name: WorkspaceEvents.openAddCreditsPage,
    });

    // Navigate to the add credits page
    if (companyId) {
      navigateToCreditsPage({ companyId });
    }
  }

  if (!isAlphaTestingEnabled || isProduction) {
    return null;
  }

  return (
    <FaroButton onClick={handleAddCredits}>
      Add {CREDITS_DISPLAY_NAME}
    </FaroButton>
  );
}
